import React, { Component } from 'react';
import { connect } from 'react-redux';
import './login.scss';
import { Button } from 'antd';
import './signUpCategory.scss';
import logo from '../../../images/logo.png';
import { fromValidate, history } from '../../../helpers'
import { commonService } from '../service';


class HomeCaregory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: []
        }
    }

    componentDidMount = () => {
        commonService.getCategories()
            .then(response => {
                this.setState({
                    categories: response || []
                })
            },
                error => {
                    console.log('not able to get categories');
                })

    }

    onSelectCategories = (id) => {
        const { user } = this.props;
        let role = user.role && user.role.name || 'Customer';
        if (role == 'Customer') {
            history.push(`/service/${id}`)
        }
        else if(role == 'Provider'){
            history.push(`/bid/${id}`)
        }
    }
    render() {
        const { user } = this.props;
        let role = user.role && user.role.name || 'Customer'
        return (
            <div className="service-box-container">
                <div className="service-images-container">
                    <div className="row">
                        {
                            this.state.categories.map((category) =>
                                <div key={category.id}
                                    onClick={() => { this.onSelectCategories(category.id) }}
                                    className="col-sm-4 col-lg-2 col-md=6 service-catg-box">

                                    {
                                        role == 'Provider' &&
                                        <div className="service-count-circle"><span>3</span></div>
                                    }

                                    <div style={{ height: '50px', width: '50px', borderRadius: '20px 0', margin: 'auto', backgroundColor: category.backgroundColor }}>
                                        <i className={`fa ${category.icon} category-icon`} aria-hidden="true"></i>
                                    </div>
                                    <div className="service-text">{category.name}</div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    return {
        user,
    }
}
export default connect(mapStateToProps)(HomeCaregory);